import { DOC_UPLOAD_FORM_INPUT_IDS } from "../enums/common";
import { FormInputItem } from "../types/common";

export interface DocUploadFormInputItem extends FormInputItem {
  id: DOC_UPLOAD_FORM_INPUT_IDS;
  value: string;
}

export const DocUploadSelectDocumentDropdownConfig: DocUploadFormInputItem[] = [
  {
    value: "",
    hasError: false,
    required: true,
    label: "Select the document to get started",
    labelTranslationKey: "Checklist-docUpload-select-label",
    errorMessage: "Please select the document",
    errorMessageTranslationKey: "Checklist-docUpload-select-error",
    id: DOC_UPLOAD_FORM_INPUT_IDS.SELECT_SINGLE_DROPDOWN,
    name: "docUploadSelectDropdown",
    dataKey: "docUploadDropdown",
    type: "select",
    selectOptions: [],
    placeholder: "Select document",
    placeholderTranslationKey: "Checklist-docUpload-select-placeholder",
  },
];

export const DocUploadSelectDocumentMultiDropdownConfig: DocUploadFormInputItem[] = [
  {
    value: "",
    hasError: false,
    required: true,
    label: "First select what citizenship you have",
    labelTranslationKey: "Checklist-docUpload-select-label",
    errorMessage: "Please select the citizenship type",
    errorMessageTranslationKey: "Checklist-docUpload-select-error",
    id: DOC_UPLOAD_FORM_INPUT_IDS.SELECT_MULTIPLE_DROPDOWN_PARENT,
    name: "docUploadSelectParentDropdown",
    dataKey: "docUploadParentDropdown",
    type: "select",
    selectOptions: [],
    placeholder: "Select Citizenship",
    placeholderTranslationKey: "Checklist-docUpload-select-placeholder",
  },
  {
    value: "",
    hasError: false,
    required: true,
    label: "Select the document to get started",
    labelTranslationKey: "Checklist-docUpload-select-label",
    errorMessage: "Please select the document",
    errorMessageTranslationKey: "Checklist-docUpload-select-error",
    id: DOC_UPLOAD_FORM_INPUT_IDS.SELECT_MULTIPLE_DROPDOWN_CHILDREN,
    name: "docUploadSelectDropdown",
    dataKey: "docUploadDropdown",
    type: "select",
    selectOptions: [],
    placeholder: "Select document",
    placeholderTranslationKey: "Checklist-docUpload-select-placeholder",
  },
];

export const TEMPORARY_SUBMIT_BUTTON_DISABLED_SOLUTION_SELECTOR = "temporary-submit-button-disabled-solution";
